import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { MonitorRoute } from "@/components/auth/MonitorRoute";
import { RecepcionistaRoute } from "@/components/auth/RecepcionistaRoute";
import Recepcionista from "@/pages/Recepcionista";
import GestionReservas from "@/pages/GestionReservas";
import Index from "@/pages/Index";
import Auth from "@/pages/Auth";
import Intro from "@/pages/Intro";
import Clases from "@/pages/Clases";
import Configuracion from "@/pages/Configuracion";
import GestionClases from "@/pages/GestionClases";
import GestionNoticias from "@/pages/GestionNoticias";
import TotalUsuarios from "@/pages/TotalUsuarios";
import TotalPagos from "@/pages/TotalPagos";
import ArqueoCaja from "@/pages/ArqueoCaja";
import Pagos from "@/pages/Pagos";
import Rutina from "@/pages/Rutina";
import BuscarRutinas from "@/pages/BuscarRutinas";
import PortafolioRutinas from "@/pages/PortafolioRutinas";
import EditarRutinaPortafolio from "@/pages/EditarRutinaPortafolio";
import Recompensas from "@/pages/Recompensas";
import { WorkoutView } from "@/components/routines/workout/WorkoutView";
import PlanView from "@/pages/PlanView";
import GestionAsistencia from "@/pages/GestionAsistencia";
import ChangePassword from "@/pages/ChangePassword";
import ForzarCambioPassword from "@/pages/ForzarCambioPassword";
import EmailConfirmed from "@/pages/EmailConfirmed";
import EstadisticasGimnasio from "@/pages/EstadisticasGimnasio";
import Monitor from "@/pages/Monitor";
import MensajesSocios from "@/pages/MensajesSocios";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/auth" element={<Auth />} />
      <Route path="/auth/recover" element={<Auth />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route
        path="/forzar-cambio-password"
        element={
          <ProtectedRoute>
            <ForzarCambioPassword />
          </ProtectedRoute>
        }
      />
      <Route path="/email-confirmed" element={<EmailConfirmed />} />
      <Route path="/intro" element={<Intro />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Index />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clases"
        element={
          <ProtectedRoute>
            <Clases />
          </ProtectedRoute>
        }
      />
      <Route
        path="/configuracion"
        element={
          <ProtectedRoute>
            <Configuracion />
          </ProtectedRoute>
        }
      />
      <Route
        path="/recompensas"
        element={
          <ProtectedRoute>
            <Recompensas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gestion-clases"
        element={
          <ProtectedRoute>
            <GestionClases />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gestion-clases/:gymId"
        element={
          <ProtectedRoute>
            <GestionClases />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gestion-noticias"
        element={
          <ProtectedRoute>
            <GestionNoticias />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gestion-noticias/:gymId"
        element={
          <ProtectedRoute>
            <GestionNoticias />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gestion-asistencia/:classId"
        element={
          <ProtectedRoute>
            <GestionAsistencia />
          </ProtectedRoute>
        }
      />
      <Route
        path="/total-usuarios"
        element={
          <ProtectedRoute>
            <TotalUsuarios />
          </ProtectedRoute>
        }
      />
      <Route
        path="/total-pagos"
        element={
          <ProtectedRoute>
            <TotalPagos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/arqueo-caja"
        element={
          <ProtectedRoute>
            <ArqueoCaja />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pagos"
        element={
          <ProtectedRoute>
            <Pagos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rutina"
        element={
          <ProtectedRoute>
            <Rutina />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rutina/buscar"
        element={
          <ProtectedRoute>
            <BuscarRutinas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rutina/portafolio"
        element={
          <ProtectedRoute>
            <PortafolioRutinas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rutina/portafolio/:routineId/editar"
        element={
          <ProtectedRoute>
            <EditarRutinaPortafolio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rutina/:routineId"
        element={
          <ProtectedRoute>
            <WorkoutView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rutina/plan/:planId"
        element={
          <ProtectedRoute>
            <PlanView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/estadisticas-gimnasio/:gymId"
        element={
          <ProtectedRoute>
            <EstadisticasGimnasio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mensajes-socios/:gymId"
        element={
          <ProtectedRoute>
            <MensajesSocios />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitor"
        element={
          <MonitorRoute>
            <Monitor />
          </MonitorRoute>
        }
      />
      <Route
        path="/recepcionista"
        element={
          <RecepcionistaRoute>
            <Recepcionista />
          </RecepcionistaRoute>
        }
      />
      <Route
        path="/gestion-reservas/:gymId"
        element={
          <ProtectedRoute>
            <GestionReservas />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};
